/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Interceptor module for checking responses for the errors related to maintenance mode.
 */
'use strict';

angular
  .module('interceptor.maintenance', [])
  /**
   * A factory that registers the interceptor logic checking for errors related to the maintenance mode.
   */
  .factory('maintenanceModeInterceptor', function ($q, $rootScope, $filter, HTTP_ERROR_STATUS) {
    return {
      // On response failure
      responseError: function (rejection) {
        if (rejection.status === HTTP_ERROR_STATUS.MAINTENANCE_MODE) {
          $rootScope.maintenanceModeFlag = true;
          if (rejection.data.message) {
            $rootScope.maintenanceMessage = rejection.data.message;
          }
          return rejection;
        } else {
          // Return the promise rejection for other errors.
          return $q.reject(rejection);
        }
      }
    };
  });
